import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommissionDto, CommissionType } from '@app/data/amn-api/models';
import { PrimeNgModule } from '@app/shared/primeng/primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-commissions',
  imports: [
    PrimeNgModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    SharedModule
  ],
  templateUrl: './commissions.component.html',
  styleUrls: ['./commissions.component.scss']
})
export class CommissionsComponent {
  @Input() commissions!: CommissionDto[];
  @Output() typeSelected = new EventEmitter<string>();
  @Output() uploadDocument = new EventEmitter<void>();
  @Output() requestDownloadDocument = new EventEmitter<{
    documentId: number;
    filename?: string;
  }>();

  filteredCommissions!: CommissionDto[];

  allowedUploadTransactionTypes = [
    CommissionType.Fa_Commission,
    CommissionType.Supervisor_Commission,
    CommissionType.Marketing
  ];

  clear(table: Table) {
    table.clear();
  }
}
